exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".list ul{background:#fff}.list .list-item{margin-bottom:0;border-bottom:1px solid #eae9e9}.list .list-item span{cursor:pointer}.list .list-item span.checked{text-decoration:line-through;font-style:italic;color:#d0d0d0}.list .list-item i{vertical-align:-5px}.list .list-item button{display:inline-block;width:auto;margin:0}.back-link{float:left}.add-link{float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-7381d785","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/List.vue
// module id = 76
// module chunks = 0